export function getPersistedOldFileValue(file) {
  if (typeof file === "string") {
    return file;
  }

  return file?.path || "";
}

export function applyOldFileFields(formData, fileFlags) {
  fileFlags.forEach((item) => {
    const oldFileValue = getPersistedOldFileValue(item.file);

    if (item.flag && oldFileValue) {
      formData[`${item.name}_Old`] = oldFileValue;
    }
  });

  return formData;
}